import * as Yup from "yup";

//First & Last Name Validation
const nameSchema = Yup.object().shape({
  name: Yup.string("Please enter a string")
    .required("Required")
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .max(50).nullable(),
});

export const validateName = (name) => {
  return nameSchema
    .validate({ name: name })
    .then(() => {
      return { ok: true, message: null };
    })
    .catch((error) => {
      return { ok: false, message: error.errors[0] };
    });
};

//Email Input Validation
const emailSchema = Yup.object().shape({
  email: Yup.string("Please Enter a String")
    .email("Invalid email address")
    .required("Required").nullable(),
});

export const validateEmail = (email) => {
  return emailSchema
    .validate({ email: email })
    .then(() => {
      return { ok: true, message: null };
    })
    .catch((error) => {
      return { ok: false, message: error.errors[0] };
    });
};

const basicStringSchema = Yup.object().shape({
  text: Yup.string("Please enter a string").required("Required").max(50).nullable(),
});

export const validateBasicString = (text) => {
  return basicStringSchema
    .validate({ text: text })
    .then(() => {
      return { ok: true, message: null };
    })
    .catch((error) => {
      return { ok: false, message: error.errors[0] };
    });
};


const basicTextAreaStringSchema = Yup.object().shape({
  text: Yup.string("Please enter a string").required("Required").nullable()
});

export const validateBasicTextAreaString = (text) => {
  return basicTextAreaStringSchema
    .validate({ text: text })
    .then(() => {
      return { ok: true, message: null };
    })
    .catch((error) => {
      return { ok: false, message: error.errors[0] };
    });
};


const termsCheckSchema = Yup.object().shape({
  termsCheck: Yup.bool().oneOf([true], 'Required!')
});

export const validateTermsCheck = (flag) => {
  return termsCheckSchema
    .validate({ termsCheck: flag })
    .then(() => {
      return { ok: true, message: null };
    })
    .catch((error) => {
      return { ok: false, message: error.errors[0] };
    });
};

